import ApiHook from './axiosAPI'

const { apiPOST, apiGET } = ApiHook()

const ChatAPI = {
  BuscarChatAgendamentos: async (idusuario, limit, offset, countAll) => {
    const url = `/chat/buscarPorUsuarioCaixaEntrada/?id=${idusuario}&limit=${limit}&offset=${offset}&countAll=${countAll}&versaoApp=${38}`
    const req = await apiGET(url)
    return req
  },
  BuscarChatDiretos: async (idusuario, limit, offset, countAll) => {
    const url = `/chat/buscarPorUsuarioCaixaEntradaEmpresas/?idusuario=${idusuario}&limit=${limit}&offset=${offset}&countAll=${countAll}`
    const req = await apiGET(url)
    return req
  },
  SelectChatAgendId: async idchat => {
    const url = `/chat/buscarPorId/?id=${idchat}`
    const req = await apiGET(url)
    return req
  },
  SelectChatDirectId: async (idchat, idusuario) => {
    const url = `/chat/buscarChatIdEmpresaUsuario/?idchat=${idchat}&idusuario=${idusuario}`
    const req = await apiGET(url)
    return req
  },
  OpenChatEmpresa: async (idempresa, idusuario) => {
    const url = `/chat/buscarChatEmpresaUsuario/?isGestor=${false}`
    const req = await apiPOST(url, { idempresa, idusuario, abertoPor: 'usuario' })
    return req
  },
  AtualizarMensagemLida: async idchat => {
    const url = `/chat/mensagensLidas/?isGestor=${false}`
    const req = await apiPOST(url, { idchat: idchat, lidaPeloGestor: false })
    return req
  },
  CheckInboxUser: async idusuario => {
    const url = `/chat/buscarChatNaoLidoUsuario/?id=${idusuario}&newVersion=${true}`
    const req = await apiGET(url)
    return req
  },
}

export default ChatAPI
